export enum ClickPath {
  CUSTOMER = 'Customer',
  GUEST = 'Guest',
  SKIPPED = 'Skipped',
  DIRECT = 'Direct',
}
